import React, { useEffect, useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";

function MatchSelectByFile({
    loaded, 
    selectionMatchingLevel, 
    chartMatchLevel, 
    matchLevels, 
    handleChange, 
    thisFilter,
    filtered
    }) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [matchLevel, setMatchLevel] = useState(selectionMatchingLevel);
    const [matchLevelIcon, setMatchLevelIcon] = useState(null);
    const [showByFile, setShowByFile] = useState(false);

    const handleMatchLevelChange = (ev) => {
        if (typeof(ev.currentTarget.value) !== "undefined" && ev.currentTarget.value !== matchLevel) {
            setMatchLevel(ev.currentTarget.value);
            handleChange(ev.currentTarget.value, thisFilter);
        }
    }

    const getSelectionMatchIcon = (level) => {
        if (!level) return matchLevels[0].icon;
        let icon = "";
        if (matchLevels && matchLevels.length > 0) {
            const foundIcon = matchLevels.find(item => {
                // If 'By File' and filter match exists use it, or use 'individual'. If Not 'By File' use the existing global match level.
                const defaultLevel = thisFilter.id === "persontype" ? "individual" : matchLevels[0].value;
                const filterLevel = (level === "file") ? thisFilter.match_level || defaultLevel : matchLevel;
                return item.value === filterLevel;
            });
            icon = (foundIcon && foundIcon.hasOwnProperty('icon')) ? foundIcon.icon : matchLevels[0].icon;
        }
        return icon;
    }
    
    useEffect(() => { 
        if(!loaded) return;
        setMatchLevelIcon(getSelectionMatchIcon(matchLevel));
        setShowByFile(chartMatchLevel === "file");
        // eslint-disable-next-line
    }, [matchLevel, chartMatchLevel]);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const displayMatchLevels = thisFilter.id === "Prospect"
      ? matchLevels.filter(item => item.value === "individual")
      : matchLevels;

  return (
      <div className={`selection-match-level-file ${filtered ? "filtered" : ""}`}>
          {!showByFile &&
            <i className={matchLevelIcon}></i>
          }
          {showByFile &&
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle caret><i className={matchLevelIcon}></i></DropdownToggle>
                <DropdownMenu>
                {displayMatchLevels.map((item, index) => (
                    <DropdownItem
                        onClick={(e) => handleMatchLevelChange(e)}
                        key={thisFilter.id + index} 
                        value={item.value}
                    >
                    <i className={item.icon}></i> {item.label}
                    </DropdownItem>

                ))}
                </DropdownMenu>
            </Dropdown>
        }
    </div>
  );
}

export default MatchSelectByFile;
